import React from 'react';
import { Fade } from "react-awesome-reveal";
import { Link } from "react-router-dom";
import { IndustriesContent } from '../../api/homepage';
import Industries from '../../api/industries';
import hicon from '../../images/icon/building.svg'

const IndustrieSection = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className="industrie m-lr pt-140 pb-140">
            <div className="industrie-wrap sec-bg pos-rel pt-130 pb-130">
                <div className="container">
                    <div className="sec-title--two text-center mb-30">
                        <Fade direction='down' triggerOnce={'false'} duration={1000} delay={9}>
                            <div>
                                <div className="sub-title wow fadeInDown" data-wow-duration="600ms">
                                    <img src={hicon} alt="" />{IndustriesContent.subtitle}
                                </div>
                            </div>
                        </Fade>
                        <Fade direction='up' triggerOnce={'false'} duration={1200} delay={9}>
                            <div>
                                <h2 className="title wow fadeInDown" data-wow-delay="150ms" data-wow-duration="600ms">
                                    {IndustriesContent.title}
                                </h2>
                            </div>
                        </Fade>
                    </div>
                    <div className="row row-cols-xl-5 row-cols-md-3 row-cols-sm-2 row-cols-2">
                        {Industries.map((industry, i) => (
                            <div className="col" key={i}>
                                <Link onClick={ClickHandler} to={`/industry/${industry.slug}`} style={{ textDecoration: 'none' }}>
                                    <div className="indus-item" style={{ cursor: 'pointer', transition: 'transform 0.3s ease' }}>
                                        <div className="xb-img">
                                            <img src={industry.icon} alt={industry.title} />
                                        </div>
                                        <h3 className="xb-title">{industry.title}</h3>
                                    </div>
                                </Link>
                            </div>
                        ))}
                    </div>
                    <div className="xb-btn text-center mt-60">
                        <Link onClick={ClickHandler} to={IndustriesContent.cta.link} className="thm-btn thm-btn--aso">
                            {IndustriesContent.cta.text}
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default IndustrieSection;